import { useEffect, useState } from "react";
import "./Airport.css";

const Airport = () => {
  const [ports, setPorts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const portsPerPage = 10;

  useEffect(() => {
    fetch("https://agencyapi.f-studio.in/Service/Airsteam_AirPort_List.ashx", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({}),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.Status === "Success") {
          setPorts(data.AirPorts); 
        } else {
          console.error("API Error:", data);
        }
      })
      .catch((err) => {
        console.error("Fetch error:", err);
      });
  }, []);

  const filteredPorts = ports.filter((port) =>
    port.PortName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredPorts.length / portsPerPage);
  const startIndex = (currentPage - 1) * portsPerPage;
  const currentPorts = filteredPorts.slice(startIndex, startIndex + portsPerPage);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  return (
    <div className="sea-port-container">
      <h2 className="title">✈️ World Air Port List</h2>
      <div className="search-pagination">
        <input
          type="text"
          placeholder="Search Port"
          value={searchTerm}
          onChange={handleSearch}
          className="search-box"
        />
      </div>

      <table className="port-table">
        <thead>
          <tr>
            <th>Port Name</th>
            <th>Port Code</th>
            <th>Country Name</th>
          </tr>
        </thead>
        <tbody>
          {currentPorts.map((port, index) => (
            <tr key={index}>
              <td>{port.PortName}</td>
              <td>{port.PortCode}</td>
              <td>{port.CountryName}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pagination">
        <button
          onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
          disabled={currentPage === 1}
        >
          ⏪
        </button>
        <span>
          {startIndex + 1} - {startIndex + currentPorts.length} of {filteredPorts.length}
        </span>
        <button
          onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
          disabled={currentPage === totalPages}
        >
          ⏩
        </button>
      </div>
    </div>
  ); 
};

export default Airport;
